import services from './../../../services/service'; // Service Class

let service = new services();

export default {
    name: 'Orders',
    data () {
        return {
          user: {},
          orders:{},
          order: {},
          img_product_url: service.imageProductsURL,
        }
      },
    components: {
        
      },
      
    methods:{
        setOrder(order){
            this.order = order;
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                        }, this);
                    }else {
                    this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                        //console.log(err)
                    }
                })
            }else {
            this.$router.push('login');
            }
        },

        getOrders(){
            service.getOrders(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.orders = response.body.data;
                    this.orders.set = true;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

    },
    created(){
        document.title = "Orders" + " | SP";
        //this.prepCart();
        this.preset();
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/Orderpoint/Orders/script.js